module.exports = __webpack_public_path__ + "media/images/athletes/1850-f76fdb9e3f69421c28c4d3d53293d0ca.png";